import { render } from "./completed-coupons.vue?vue&type=template&id=2d212e83"
import script from "./completed-coupons.vue?vue&type=script&lang=js"
export * from "./completed-coupons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__